import Vue from 'vue';
import Moment from 'moment';
import {Api} from './api';
import * as Common from '@/agiles/common';


// JSONの日付変換方法をカスタマイズする
Date.prototype.toJSON = function() {
  // return Moment(this).toISOString();//タイムゾーンが考慮されてしまう
  // return Moment(this).format("YYYY-MM-DDTHH:mm:ss.000") + "Z"; //タイムゾーンをドロップする
    return Moment(this).format("YYYY-MM-DDTHH:mm:ss.000"); //タイムゾーンをドロップする
};
// Date.prototype.toISOString = function() {
//   // return Moment(this).toISOString();//タイムゾーンが考慮されてしまう
//   return Moment(this).format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z"; //タイムゾーンをドロップする
// };

JSON.parseWithDate = str => {
  function reviver(key: string, val: any) {
    if (typeof val === 'string' && val.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3,7}?)?$/)) {
      return new Date(Date.parse(val));
    }
    return val;
  }
  return JSON.parse(str, reviver);
};

Date.prototype.getCalendarDate = function() {
    //UTC時刻での日付を取得します
    return new Date(this.getFullYear(),this.getMonth(),this.getDate());
}
Date.prototype.getBeginDate = function() {
    //月初日を取得します。
    return new Date(this.getFullYear(),this.getMonth(),1);
}
JSON.stringify2 = function(obj) {
            const temp= JSON.stringify(obj,(_, v) => (!(v instanceof Array || v === null) && typeof v == "object") ? 
          Object.keys(v).filter((item)=>item != "binders" && item != "className" && item != "responseBinder").sort().reduce((r, k) => { (r as any)[k] = v[k]; return r }, {}) : v);
          return temp;
}
// フォーマッター
// 値を表示テキストに変換するフォーマッタの定義(数値/日付/enum/boolean/マスタ)
export class Formatter {
  public vm : Vue;
  public vmChilds :Vue[];
  
  private hash: { [listKey: string]: BindItem[]} = {};
  private lazyLoad: {[listKey:string]:boolean} = {};
  // private callback: {[listKey:string]:Array<()=>void>} = {};
  private ajax = new Array<string>();
  private api: Api;
  constructor(api: Api) {
    // システムフォーマッタ(数値・日付)を登録する
    this.api = api;
    Vue.filter('numeric', (value: any, decimals: number) => this.formatNumber(value, decimals));
    Vue.filter('amountFC', (value: any,currency:string) => this.formatAmountFC(value,currency));
    Vue.filter('amount', (value: any) => this.formatAmount(value));
    Vue.filter('date', (value: any) => this.formatDate(value));
    Vue.filter('dateYM', (value: any) => this.formatDateYM(value));
    Vue.filter('dateMD', (value: any) => this.formatDateMD(value));
    Vue.filter('timestamp', (value: any) => this.formatTimeStamp(value));
    Vue.filter('datetime', (value: any,format:string) => this.formatDateTime(value,format));
    Vue.filter('enum', (value: any,listName:string) => this.formatEnum(value,listName));    
  }
  //#region 静的フォーマット
  public formatNumber(value: number, decimals: number) {
    const formatter = (decimals || decimals == 0 ) ? new Intl.NumberFormat('ja-JP', { minimumFractionDigits: decimals }) : new Intl.NumberFormat('ja-JP',{maximumFractionDigits: 6});
    return formatter.format(value);
  }

  public formatAmountFC(value: number, currency: string)
  {
    var formatter = new Intl.NumberFormat('ja-JP');
    const obj = this.api.currencies.filter(obj => obj.value == currency);
    if (obj.length > 0) formatter = new Intl.NumberFormat('ja-JP',{minimumFractionDigits: Number(obj[0].text)});
    return formatter.format(value);
  }

  public formatAmountFCMark(value: number, currency: string)
  {
    if (value == null) return null;
    var formatter = new Intl.NumberFormat('ja-JP');
    const obj = this.api.currencies.filter(obj => obj.value == currency);
    if (obj.length > 0) {
      formatter = new Intl.NumberFormat('ja-JP',{minimumFractionDigits: Number(obj[0].text)});
      return this.api.currencieMarks.filter(obj=>obj.value==currency)[0].text + formatter.format(value);
    }
    else return formatter.format(value);
  }

  public formatAmount(value: number)
  {
    const formatter = new Intl.NumberFormat('ja-JP',{minimumFractionDigits: this.api.systemCurrencyPrecision});
    return formatter.format(value);
  }
  public formatEnum(value: number,listName:string)
  {
      var enumItems = this.hash[listName];
      var results = new Array();
      enumItems.forEach(obj =>{ if ( (value & obj.value as number) > 0) results.push(obj.text) });
      return results.join("・");
  }
  public formatDate(value: Date) {
    if (value==null) return '';
    else return Moment(value).format('YYYY-MM-DD');
  }

  public formatDateYM(value: Date) {
    if (value==null) return '';
    else return Moment(value).format('YYYY-MM');
  }

  public formatDateMD(value: Date) {
    if (value==null) return '';
    else return Moment(value).format('M-D');
  }

  public formatTimeStamp(value: Date) {
    if (value==null) return '';
    else return Moment(value).format('YYYY-MM-DD HH:mm:ss');
  }
  public formatDateTime(value: Date,format:string) {
    if (value==null) return '';
    else return Moment(value).format(format);
  }

  //#endregion

  /**サーバーリストを初期化します */
  public async initialize(listName: string, ajax:boolean=false){      
      if(ajax) {
          this.hash[listName] = new Array<BindItem>();
          this.ajax.push(listName);
      } else {
          // await this.api.list(listName).then(res=>this.hash[listName]= res);//バグ対応が完了したので戻し
          //this.pendingLists.push(listName); OnDemandに変更
      } 
      Vue.filter(listName, (value: any) => this.formatByList(value, listName));
  }

  pendingLists = new Array<string>(); //スタティックリスト

  //保留モード
  isSuspended:boolean = false;
  pendingCallbacks = new Array<(value?:any)=>void>();

　public suspendLoading(){
    this.isSuspended = true;
  }
  public resumeLoading(){
    this.isSuspended = false;    
  }
  public async waitPendingLists(){
    if (this.isSuspended){
      return new Promise((resolve,reject) =>{
        this.pendingCallbacks.push(resolve);
      });
    } else {
      return this.loadPendingLists();
    }
  }

  public async loadPendingLists(){
    
     //OnDemandの呼び出しリストを解決する
     if (this.hasPendingRequests()) {
       //保留モードをクリア
       this.isSuspended = false;

      //  console.log('loadPendingLists');
      //  this.pendingLists.forEach(name => console.log(name));
      //  Object.keys(this.lazyLoad).forEach(name => console.log(name));

        var query = new Common.ListQuery();
        query.list = this.pendingLists;
        //ajaxも取得できるようにする
        Object.keys(this.lazyLoad).forEach(name => {
            query.ajaxList[name] = this.hash[name].filter(obj=>obj.text == null).map(obj=>obj.value);
        });
        //リストを先に空にする～実行中に追加される場合がある。
        this.lazyLoad = {};     
        this.pendingLists = new Array();

        await this.api.execute(query).then(res =>{
          var result = res as Common.ListResult[];
          result.forEach(obj =>{
            this.updateHash(obj.listName,obj.items);
          });
        });

        //待機中のプロミスをリリースする
        this.pendingCallbacks.forEach(callback => callback());
        this.pendingCallbacks = new Array();
        
     }
  }

  public clearList(loadLicense :boolean, ...listNames :string[]){
    listNames.forEach(name =>{
      if (this.hash[name]) delete this.hash[name];
    });
    if(loadLicense)this.api.perms.reloadLicense();
  }

  //OnDemandの呼び出しリストの有無を取得する
  public hasPendingRequests() :boolean {
    return this.pendingLists.length != 0 || Object.keys(this.lazyLoad).length != 0 ;
  }
  /**静的リストを初期化します */
  public initializeConstant(listName: string, items:BindItem[]){
        this.hash[listName] = items;
        Vue.filter(listName, (value: any) => this.formatByList(value, listName));
  }
  
  // public subscribe(callback:()=>void,listName:string = 'global'){
  //   if (!this.callback[listName]) this.callback[listName] = new Array<()=>void>();
  //   if (this.callback[listName].find(obj => obj == callback)==null) this.callback[listName].push(callback);
  // }

  // public unsubscribe(callback:()=>void,listName:string = 'global'){
  //   var index = this.callback[listName].indexOf(callback);
  //   if (index > -1) this.callback[listName].splice(index,1);
  // }

  /**同期処理でフォーマットし、遅延ロードが発生する場合はコールバックを呼び出します */
  public formatByList(value: any, listName: string):string {

    const temp = this.hash[listName] ? this.hash[listName].find(obj => obj.value === value) : null;

    if (this.ajax.find(obj=>obj == listName)) {
        //ajax対応リストの場合は、遅延ロードする
        //同期メソッド内では非同期メソッドの待機ができないので呼び出し元のvueを再描画
        if (temp == null && value != null && value != '') {
          //遅延ロード～同じ呼び出しが連続して発生しないようにキーを先に追加して後で更新する
          this.hash[listName].push(new BindItem(value,null));  

          //コールバック方式を廃止する～明示的にロードする
          // if (Object.keys(this.lazyLoad).length == 0){
          
          //   //初期描画完了後にまとめてリストを更新する
          //   Vue.nextTick(async () => {
          //     Object.keys(this.lazyLoad).forEach(async name => {
          //     var keys = this.hash[name].filter(obj=>obj.text == null).map(obj=>obj.value);
          //     await this.api.listAjax(name, keys).then(res => {
          //       this.updateHash(name,res.result);
          //       if (this.callback[name])this.callback[name].forEach(v =>v());       
          //     });
          //     //再描画
          //     this.callback['global'].forEach(v =>v());         
          //     //リセットする
          //     this.lazyLoad = {};
          //     });
          //   });
          // }

          if (! this.lazyLoad[listName]) this.lazyLoad[listName] = true;

          return '';
        } else {
          return temp != null ? temp.text : '';
        }
    } else if (! this.hash[listName]) {
      //リストが未ロードの場合
      if (this.pendingLists.indexOf(listName) == -1) this.pendingLists.push(listName);
      return '';
    } else {
      //ajax非対応リストの場合は、そのまま返す
       return temp != null ? temp.text : '';
    }

  }

  public getOptions(listName: string): BindItem[] {
    if (this.hash[listName] == null) {
      if(this.pendingLists.indexOf(listName) == -1) this.pendingLists.push(listName);//ロードされていない場合はpendingListに追加する
      return new Array(0);
    } else {
    return this.hash[listName];
    }
  }
  
  /**非同期処理でフォーマットします */
  public formatByListAjax(value: any, listName: string): Promise<string> {

    if (this.ajax.find(obj=>obj == listName)) {
      var temp = this.hash[listName].find(obj=>obj.value == value);  
      if (temp && temp.text) return Promise.resolve(temp.text);
      else 
        return this.api.listAjax(listName, [value]).then(res => {
          this.updateHash(listName,res.result);
          return Promise.resolve(res.records >= 1 ? res.result[0].text:'');
        });
    } else {    
      return this.ensureListLoaded(listName).then(()=>{
        //ロード待ちの場合は空文字
        if (!this.hash[listName]) return Promise.resolve('');

        var temp = this.hash[listName].find(obj=>obj.value == value);          
        //ajax非対応リストの場合は、そのまま返す
        return Promise.resolve(temp == null ? '' : temp.text);
      });
    }    
  }

  public async getOptionsAjax(listName:string, search:string, perPage: number, targetPage:number) : Promise<Common.LoadResult>{
      if (this.ajax.find(obj=>obj == listName)) {
          return this.api.listAjax(listName, new Array(),search,perPage,targetPage).then(res => {this.updateHash(listName,res.result); return Promise.resolve(res);});
      } else {
          return this.ensureListLoaded(listName).then(()=>{

            //ロード待ちの場合は空文字
            if (!this.hash[listName]) return Promise.resolve(new Common.LoadResult(Common.BindItem2));

            //ajax非対応リストの場合は、ローカルでページ処理を実行する
            var baseList = this.hash[listName].filter(obj=>obj.text && obj.text.toLowerCase().includes(search.toLowerCase()));
            var result = new Common.LoadResult(Common.BindItem2);
            result.records = baseList.length;
            result.result = baseList.slice(perPage * (targetPage -1), perPage * targetPage);
            return Promise.resolve(result);
          });
      } 
  }


  async ensureListLoaded(...listNames :string[]): Promise<any>{

    listNames.forEach(name =>{
      if (!this.hash[name] && this.pendingLists.indexOf(name) < 0) this.pendingLists.push(name);
    });

    //都度ロードするとパフォーマンスの劣化が激しいので登録のみに変更
    // if (this.pendingLists.length == 0) return Promise.resolve();
    // else return this.loadPendingLists();

    //保留ロードor都度ロードを選択できるようにして復活。ロード待ちでもPromiseを返すように変更。
    if (this.pendingLists.length == 0) return Promise.resolve();
    else return this.waitPendingLists();

  }
 //**hashの追加・更新～ロードしたデータで都度更新する*/
  updateHash(listName:string, items:BindItem[]){
    //空のコレクションも登録する必要がある
  if (! this.hash[listName]) this.hash[listName] = new Array<BindItem>();    
   items.forEach(item =>{
        var target = this.hash[listName].find(obj=>obj.value== item.value);
        if (target) target.text = item.text;
        else this.hash[listName].push(item);
   }) ;
  }
}

export class BindItem {
  public value: any;
  public text: string;
  constructor(value: any, text: string) {
    this.value = value;
    this.text = text;
  }
}

